(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guide-library"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('guide-library-search')) {
    customElements.define('guide-library-search', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('.guide-library__search');
        this.input = this.form.querySelector('[name="q"]');
        this.results = this.querySelector('[data-guide-search-results]');
        this.content = this.querySelector('[data-guide-search-content]');
        this.status = this.querySelector('[data-guide-search-status]');
        this.browse = this.querySelector('[data-guide-browse]');
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.search();
        });
        this.querySelector('[data-guide-search-clear]').addEventListener('click', () => {
          this.request?.abort();
          this.results.hidden = true;
          this.browse.hidden = false;
          this.input.value = '';
          this.input.focus();
        });
        this.addEventListener('click', (event) => {
          const brand = event.target.closest('[data-guide-brand-search]');
          const next = event.target.closest('[data-guide-search-next]');
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (brand) {
            event.preventDefault();
            this.input.value = brand.dataset.guideBrandSearch;
            this.search();
          } else if (next) {
            event.preventDefault();
            this.load(next.href, true);
          }
        });
      }

      disconnectedCallback() {
        this.request?.abort();
      }

      search() {
        if (!this.input.value.trim()) return;
        const url = new URL(this.form.action, window.location.origin);
        url.search = new URLSearchParams(new FormData(this.form)).toString();
        this.load(url, false);
      }

      async load(address, append) {
        this.request?.abort();
        const controller = new AbortController();
        this.request = controller;
        const url = new URL(address, window.location.origin);
        url.searchParams.set('view', 'guide-library');
        url.searchParams.set('type', 'article');
        this.results.hidden = false;
        this.browse.hidden = true;
        this.results.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.guideLoading;
        if (!append) this.content.replaceChildren();
        try {
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fragment = documentResult.querySelector('[data-guide-search-fragment]');
          if (!fragment) throw new Error('Search results unavailable');
          this.status.textContent = fragment.querySelector('[data-guide-search-summary]').textContent;
          fragment.querySelector('[data-guide-search-summary]').remove();
          if (append) {
            const grid = this.content.querySelector('[data-guide-search-grid]');
            const newGrid = fragment.querySelector('[data-guide-search-grid]');
            grid.append(...newGrid.children);
            this.content.querySelector('[data-guide-search-pagination]')?.remove();
            const pagination = fragment.querySelector('[data-guide-search-pagination]');
            if (pagination) this.content.append(pagination);
          } else {
            this.content.replaceChildren(fragment);
            const heading = this.querySelector('[data-guide-search-heading]');
            heading.focus({ preventScroll: true });
            this.results.scrollIntoView({ block: 'start' });
          }
        } catch (error) {
          if (error.name !== 'AbortError') this.status.textContent = this.dataset.guideError;
        } finally {
          if (this.request === controller) this.results.setAttribute('aria-busy', 'false');
        }
      }
    });
  }

  if (!customElements.get('guide-load-more')) {
    customElements.define('guide-load-more', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link) return;
        this.link.addEventListener('click', this.load.bind(this));
      }

      async load(event) {
        event.preventDefault();
        if (this.classList.contains('is-loading')) return;
        this.classList.add('is-loading');

        try {
          const response = await fetch(this.link.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load guides');
          const html = await response.text();
          const nextDocument = new DOMParser().parseFromString(html, 'text/html');
          const currentGrid = this.closest('[data-guide-library]').querySelector('[data-guide-grid]');
          const nextGrid = nextDocument.querySelector('[data-guide-grid]');
          const nextControl = nextDocument.querySelector('[data-guide-next] a');

          if (nextGrid) {
            [...nextGrid.children].forEach((card) => currentGrid.appendChild(card));
          }

          if (nextControl) {
            this.link.href = nextControl.href;
            const nextStatus = nextDocument.querySelector('.guide-library__page-status');
            const currentStatus = this.querySelector('.guide-library__page-status');
            if (currentStatus && nextStatus) currentStatus.textContent = nextStatus.textContent;
            this.classList.remove('is-loading');
          } else {
            this.remove();
          }
        } catch (error) {
          window.location.assign(this.link.href);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
